import { render, staticRenderFns } from "./minichart.vue?vue&type=template&id=d2dacf7a&scoped=true&"
import script from "./minichart.vue?vue&type=script&lang=js&"
export * from "./minichart.vue?vue&type=script&lang=js&"
import style0 from "./minichart.vue?vue&type=style&index=0&id=d2dacf7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dacf7a",
  null
  
)

export default component.exports